// extracted by mini-css-extract-plugin
export default {"tagsWrap":"Tags__tagsWrap___AFQtx"};